<template>
  <div class="login-bg">
    <div class="login-area">
      <div class="login-title">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="ThisAdmin管理系统">
        </div>
        <div class="tit">用户登录</div>
      </div>
      <div class="login-body">
        <div class="login-input">
          <label class="icon"> <i class="iconfont el-icon-user"></i> </label>
          <input type="text" class="input" name="username" v-model.trim="username" placeholder="请输入用户名/手机号">
        </div>
        <div class="login-input">
          <label class="icon"> <i class="iconfont el-icon-unlock"></i> </label>
          <input type="password" class="input" name="password" v-model.trim="password" @keyup.enter="login" placeholder="请输入密码">
        </div>
        <div class="login-input">
          <input type="submit" class="input-submit" @click="login" value="登入">
        </div>
      </div>
    </div>
    <div class="login-footer">
      <el-link class="copyright" type="info" target="_blank" href="http://www.thisadmin.cn">Powered by ThisAdmin ©2016-{{new Date().getFullYear()}} 版权所有 山东正则信息技术有限公司</el-link>
    </div>
  </div>
</template>

<script>
import account from "@/api/account";
import {setTokenAndAccount} from "../utils/auth";
export default {
  name: "login",
  data() {
    return {
      username:'',
      password:''
    }
  },
  methods: {
    async login() {
      const that = this;
      //管理后台登录
      await account.login({
        username: this.username,
        password: this.password
      }).then(function (res){
        if(res){
          setTokenAndAccount(res.data.token,res.data.account);
          that.$router.push('/')
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.login-bg {position: fixed;width: 100%;height: 100%;background-image: url("../assets/images/login-bg.jpg");background-size: cover;background-repeat: repeat;}
.login-area {position: fixed;left: 50%;top: 50%;width: 600px;height: 400px;margin: -250px 0 0  -300px;background: rgba(255, 255, 255, 0.2);box-shadow: 0 0 20px #333;
  .login-title {width: 100%;margin: 30px 0 0 0;
    .logo {width: 100%;height: 80px;text-align: center;
      img {width: 80px;height: 80px;}
    }
    .tit {width: 100%;height: 50px;line-height: 50px;text-align: center;font-size: 20px;color: #fff;}
  }
  .login-body {width: 100%;
    .login-input {width: 86%;margin: 20px 7%;
      label {display: block; float: left; width: 80px; text-align: center; height: 50px; line-height: 50px; color: #eee; font-size: 20px; background: rgba(0, 0, 0, 0.5);}
      .input { width: 415px; padding: 0 10px; height: 50px; line-height: 50px; border: none;}
      .input-submit {width: 100%; height: 50px; line-height: 50px; border: none; background: rgba(0, 0, 0, 0.5); font-size: 18px; color: #eee; cursor: pointer;
        &:hover { background: rgba(0, 0, 0, 0.8)}
      }
      .tip {color: #e22;}
    }
  }
}
.login-footer {position: absolute;bottom: 0;left: 0;width: 100%;
  .copyright {width: 100%;height: 50px;line-height: 50px;text-align: center;color: #bebebe;font-size: 13px;}
}
</style>